<div style="padding: 15px">
    <div class="subtitle">
        <span>Informações do Certificado</span>
        <!-- Botão para fechar atendimento quando csId estiver presente -->
        <button mat-flat-button color="warn" *ngIf="csId" style="margin-left: 16px;" (click)="confirmClose()">
            Fechar Atendimento (ID: {{csId}})
        </button>
    </div>
    @if(profile == 'providerPF') {
    <div style="text-align: left;">
        <p><strong>Profile:</strong> {{ profile }}</p>
        <p><strong>ID:</strong> {{ id }}</p>
        @if(certificationProviderPFInfoDTO) {
        <div style="display: flex;">
            <!-- Exibe dados de profissão se existirem -->
            <div>
                <h6>Usuario:</h6>
                <strong>Id:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.user?.id}}<br />
                <strong>email:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.user?.email}}<br />
                <strong>firstName:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.user?.firstName}}<br />
                <strong>lastName:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.user?.lastName}}<br />
                <strong>cpf:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.user?.cpf}}<br />
                <strong>phoneNumber:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.user?.phoneNumber}}<br />
                <strong>registerDate:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.user?.registerDate | date: 'dd/MM/yyyy'}}<br />
                <strong>active:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.user?.active}}<br />
                <strong>certifiedHubMedical:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.user?.certifiedHubMedical ? 'Certificado' : 'Não Certificado'}}
                <mat-slide-toggle
                    [checked]="certificationProviderPFInfoDTO.profileProviderPF?.user?.certifiedHubMedical"
                    (change)="toggleCertification(certificationProviderPFInfoDTO.profileProviderPF?.user?.id, 'user', $event.checked)">
                </mat-slide-toggle><br />
                <strong>status:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.user?.status}}<br />
                ---------------------------------------------<br />
                <h6>Provedor PF:</h6>
                <strong>Id:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.id}}<br />
                <strong>name:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.name}}<br />
                <strong>email:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.email}}<br />
                <strong>cpf:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.cpf}}<br />
                <strong>phoneNumber:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.phoneNumber}}<br />
                <strong>cnesCode:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.cnesCode}}<br />
                <strong>registerDate:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.registerDate | date: 'dd/MM/yyyy'}}<br />
                <strong>certifiedHubMedical:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.certifiedHubMedical ? 'Certificado' : 'Não Certificado'}}
                <mat-slide-toggle [checked]="certificationProviderPFInfoDTO.profileProviderPF?.certifiedHubMedical"
                    (change)="toggleCertification(certificationProviderPFInfoDTO.profileProviderPF?.id, 'profileProviderPF', $event.checked)">
                </mat-slide-toggle><br />
                <strong>active:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.active}}<br />
                <strong>status:</strong>
                {{certificationProviderPFInfoDTO.profileProviderPF?.status}}<br />
                ---------------------------------------------------<br />
                <h6>Conselhos:</h6>
                <ul>
                    <li *ngFor="let council of certificationProviderPFInfoDTO.councils">
                        <strong>Id:</strong> {{council.id}}<br />
                        <strong>councilInscriptionNumber:</strong> {{council.councilInscriptionNumber}}<br />
                        <strong>councilGroup:</strong> {{council.councilGroup}}<br />
                        <strong>district:</strong> {{council.district}}<br />
                        <strong>firstInscriptionUF:</strong> {{council.firstInscriptionUF | date: 'dd/MM/yyyy'}}<br />
                        <strong>councilInscriptionDate:</strong> {{council.councilInscriptionDate | date: 'dd/MM/yyyy'}}<br />
                        <strong>councilStatus:</strong> {{council.councilStatus}}<br />
                        <strong>certifiedHubMedical:</strong>
                        {{council.certifiedHubMedical ? 'Certificado' : 'Não Certificado'}}
                        <mat-slide-toggle [checked]="council.certifiedHubMedical"
                            (change)="toggleCertification(council.id, 'council', $event.checked)">
                        </mat-slide-toggle><br />
                        <strong>active:</strong> {{council.active}}<br />
                        
                        <h6>Profissões do Conselho:</h6>
                        <ul>
                            <li *ngFor="let councilProfession of council.councilProfession">
                                <strong>Id:</strong> {{councilProfession.id}}<br />
                                <strong>active:</strong> {{councilProfession.active}}<br />
                                <strong>certifiedHubMedical:</strong>
                                {{councilProfession.certifiedHubMedical ? 'Certificado' : 'Não Certificado'}}
                                <mat-slide-toggle [checked]="councilProfession.certifiedHubMedical"
                                    (change)="toggleCertification(councilProfession.id, 'profession', $event.checked)">
                                </mat-slide-toggle><br />
                                <strong>Profissão:</strong> {{councilProfession.professionInfo?.professionName}}<br />
                                <strong>Especialidade:</strong> {{councilProfession.professionInfo?.specialty}}<br />
                                <strong>RQE da Especialidade:</strong> {{councilProfession.professionInfo?.specialtyRQE}}<br />
                                <strong>Áreas de Atuação:</strong>
                                <ul>
                                    <li *ngFor="let area of councilProfession.professionInfo?.activityAreas">
                                        <strong>Área:</strong> {{area.activityArea}}<br />
                                        <strong>RQE da Área:</strong> {{area.activityAreaRQE}}<br />
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <hr />
                    </li>
                </ul>
                ---------------------------------------------------<br />

                <h6>Endereços:</h6>
                <ul>
                    <li *ngFor="let address of certificationProviderPFInfoDTO.profileProviderPF?.addresses">
                        <strong>Cnes:</strong> {{address.cnesCode}}<br />
                        <strong>Id:</strong> {{address.id}}<br />
                        <strong>Street:</strong> {{address.street}}<br />
                        <strong>Number:</strong> {{address.number}}<br />
                        <strong>Complement:</strong> {{address.complement}}<br />
                        <strong>District:</strong> {{address.district}}<br />
                        <strong>City:</strong> {{address.city}}<br />
                        <strong>State:</strong> {{address.state}}<br />
                        <strong>Zip Code:</strong> {{address.zipCode}}<br />
                        <hr /><br />
                    </li>
                </ul>


            </div>

            <div>
                <app-attachment [attachments]="certificationProviderPFInfoDTO.attachments!"
                    [typeAccess]="'admin'"></app-attachment>
                <h6>Informações complementares dos documentos:</h6>
                <ul>
                    <li *ngFor="let attachment of certificationProviderPFInfoDTO.attachments">
                        <strong>Id:</strong> {{attachment.id}}<br />
                        <strong>File Name:</strong> {{attachment.fileName}}<br />
                        <strong>File Type:</strong> {{attachment.fileType}}<br />
                        <strong>File Size:</strong> {{attachment.fileSize}} bytes<br />
                        <strong>Upload Date:</strong> {{attachment.uploadDate | date: 'dd/MM/yyyy'}}<br />
                        <strong>Owner Documents CPF/CNPJ:</strong> {{attachment.ownerDocumentsCpfCnpj}}<br />
                        <strong>Expiration Date:</strong> {{attachment.expirationDate ? (attachment.expirationDate |
                        date: 'dd/MM/yyyy') : 'N/A'}}<br />
                        <strong>Expired:</strong> {{attachment.expired ? 'Sim' : 'Não'}}<br />
                        <strong>Document Type:</strong> {{attachment.documentType}}<br />
                        <strong>Share Permitted:</strong> {{attachment.sharePermitted ? 'Sim' : 'Não'}}<br />
                        <strong>Certified Hub Medical:</strong> {{attachment.certifiedHubMedical ? 'Certificado' : 'Não Certificado'}}
                        <mat-slide-toggle [checked]="attachment.certifiedHubMedical"
                            (change)="toggleCertification(attachment.id, 'document', $event.checked)">
                        </mat-slide-toggle><br />
                        <strong>Verified Attendant Date:</strong> {{attachment.verifiedAttendantDate ?
                        (attachment.verifiedAttendantDate | date: 'dd/MM/yyyy') : 'N/A'}}<br />
                        <strong>Verified Attendant Email:</strong> {{attachment.verifiedAttendantEmail ?
                        attachment.verifiedAttendantEmail : 'N/A'}}<br />
                    </li>

                </ul>
            </div>
        </div>}
    </div>}
    @if(profile == 'providerPJ') {
    <div style="text-align: left;">
        <p><strong>Profile:</strong> {{ profile }}</p>
        <p><strong>ID:</strong> {{ id }}</p>
        @if(certificationProviderPJInfoDTO) {
        <div style="display: flex;">
            <!-- Exibe dados de profissão se existirem -->
            <div>
                <h6>Provedor PJ:</h6>
                <strong>Id:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.id}}<br />
                <strong>companyName:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.companyName}}<br />
                <strong>companyMarketingName:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.companyMarketingName}}<br />
                <strong>cnpj:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.cnpj}}<br />
                <strong>phoneNumber:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.phoneNumber}}<br />
                <strong>cnesCode:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.cnesCode}}<br />
                <strong>crmTechnicalNumber:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.crmTechnicalNumber}}<br />
                <strong>businesLicenseControlNumber:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.businesLicenseControlNumber}}<br />
                <strong>pumblerLicenseControlNumber:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.pumblerLicenseControlNumber}}<br />
                <strong>businessType:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.businessType}}<br />
                <strong>email:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.email}}<br />
                <strong>registerDate:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.registerDate | date: 'dd/MM/yyyy'}}<br />
                <strong>certifiedHubMedical:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.certifiedHubMedical ? 'Certificado' : 'Não Certificado'}}
                <mat-slide-toggle [checked]="certificationProviderPJInfoDTO.profileProviderPJ?.certifiedHubMedical"
                    (change)="toggleCertification(certificationProviderPJInfoDTO.profileProviderPJ?.id, 'profileProviderPJ', $event.checked)">
                </mat-slide-toggle><br />
                <strong>active:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.active}}<br />
                <strong>status:</strong>
                {{certificationProviderPJInfoDTO.profileProviderPJ?.status}}<br />
                ---------------------------------------------------<br />
                
               
                <h6>Endereços:</h6>
                <ul>
                    <li *ngFor="let address of certificationProviderPJInfoDTO.profileProviderPJ?.addresses">
                        <strong>Cnes:</strong> {{address.cnesCode}}<br />
                        <strong>Id:</strong> {{address.id}}<br />
                        <strong>Street:</strong> {{address.street}}<br />
                        <strong>Number:</strong> {{address.number}}<br />
                        <strong>Complement:</strong> {{address.complement}}<br />
                        <strong>District:</strong> {{address.district}}<br />
                        <strong>City:</strong> {{address.city}}<br />
                        <strong>State:</strong> {{address.state}}<br />
                        <strong>Zip Code:</strong> {{address.zipCode}}<br />
                        <hr />
                    </li>
                </ul>
            </div>

            <div>
                <app-attachment [attachments]="certificationProviderPJInfoDTO.attachments!"
                    [typeAccess]="'admin'"></app-attachment>
                <h6>Informações complementares dos documentos:</h6>
                <ul>
                    <li *ngFor="let attachment of certificationProviderPJInfoDTO.attachments">
                        <strong>Id:</strong> {{attachment.id}}<br />
                        <strong>File Name:</strong> {{attachment.fileName}}<br />
                        <strong>File Type:</strong> {{attachment.fileType}}<br />
                        <strong>File Size:</strong> {{attachment.fileSize}} bytes<br />
                        <strong>Upload Date:</strong> {{attachment.uploadDate | date: 'dd/MM/yyyy'}}<br />
                        <strong>Owner Documents CPF/CNPJ:</strong> {{attachment.ownerDocumentsCpfCnpj}}<br />
                        <strong>Expiration Date:</strong> {{attachment.expirationDate ? (attachment.expirationDate |
                        date: 'dd/MM/yyyy') : 'N/A'}}<br />
                        <strong>Expired:</strong> {{attachment.expired ? 'Sim' : 'Não'}}<br />
                        <strong>Document Type:</strong> {{attachment.documentType}}<br />
                        <strong>Share Permitted:</strong> {{attachment.sharePermitted ? 'Sim' : 'Não'}}<br />
                        <strong>Certified Hub Medical:</strong> {{attachment.certifiedHubMedical ? 'Certificado' : 'Não Certificado'}}
                        <mat-slide-toggle [checked]="attachment.certifiedHubMedical"
                            (change)="toggleCertification(attachment.id, 'document', $event.checked)">
                        </mat-slide-toggle><br />
                        <strong>Verified Attendant Date:</strong> {{attachment.verifiedAttendantDate ?
                        (attachment.verifiedAttendantDate | date: 'dd/MM/yyyy') : 'N/A'}}<br />
                        <strong>Verified Attendant Email:</strong> {{attachment.verifiedAttendantEmail ?
                        attachment.verifiedAttendantEmail : 'N/A'}}<br />
                    </li>
                </ul>
            </div>
        </div>}
    </div>}
</div>